import {ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {greenColors} from '../../layouts/theme/designSystem';

export interface Props {
  moduleName: string;
  title: string;
  /** Value for `data-tour` on the page title (walkthrough anchor). */
  titleDataTour?: string;
  actions?: ReactNode;
}

export const ModulePageHeader = ({moduleName, title, titleDataTour, actions}: Props) => {
  return (
    <>
      <Typography
        sx={{
          fontSize: '14px',
          lineHeight: 1.5,
          color: greenColors[700],
          mb: 0.5,
        }}
      >
        {moduleName}
      </Typography>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 3}}>
        <Typography
          component='h1'
          data-tour={titleDataTour}
          sx={{
            fontSize: '34px',
            lineHeight: 1.5,
            fontWeight: 700,
            color: greenColors[700],
          }}
        >
          {title}
        </Typography>
        {actions}
      </Box>
    </>
  );
};
